import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Clients from './pages/Clients';
import ClientProfile from './pages/ClientProfile';
import CreativeManagement from './pages/CreativeManagement';
import GreenRoom from './pages/GreenRoom';
import BlogPost from './pages/BlogPost';
import News from './pages/News';
import NewsItem from './pages/NewsItem';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CookieConsent from './components/CookieConsent';
import AdminApp from './admin/AdminApp';
import './App.css';

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // GA4 SPA page_view — only fires if user has granted analytics_storage
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'page_view', {
          page_path: pathname,
          page_location: window.location.href,
          page_title: document.title,
        });
      } catch (err) {
        console.warn('[GA4] page_view failed:', err);
      }
    }
  }, [pathname]);
  return null;
}

function MarketingSite() {
  return (
    <>
      <Navigation />
      <main data-testid="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/:slug" element={<ClientProfile />} />
          <Route path="/creative-management" element={<CreativeManagement />} />
          <Route path="/green-room" element={<GreenRoom />} />
          <Route path="/green-room/:slug" element={<BlogPost />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsItem />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="bottom-right" theme="light" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<MarketingSite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
